import { IPendingCart } from 'models/cart/IPendingCart';
import { ICreateWorkerFormData } from 'forms/worker';
import { format } from 'date-fns';

export interface ICompleteCheckoutProps {
    portalId: string;
    companyId: string;
    employeeId: string;
    cartId: string | number;
    token: string;
    paymentId: string;
    newWorker: ICreateWorkerFormData | null;
    fatZebraToken: string;
    validation: string;
    ip: string;
}

export const completeCheckout = async ({
    portalId,
    companyId,
    employeeId,
    cartId,
    token,
    paymentId,
    newWorker,
    fatZebraToken,
    validation,
    ip
}: ICompleteCheckoutProps): Promise<IPendingCart> => {
    const perspectiveId = (window as any).ENV.REACT_APP_PERSPECTIVE_ID ? +(window as any).ENV.REACT_APP_PERSPECTIVE_ID : 70119;
    const accountServicePortalId = (window as any).ENV.REACT_APP_AS_PORTAL_ID ? +(window as any).ENV.REACT_APP_AS_PORTAL_ID : null;

    const body = {
        accountServicePortalId,
        payerId: null,
        paymentId: paymentId,
        dob: newWorker?.dob ? format(newWorker?.dob, 'yyyy-MM-dd') : null,
        perspectiveId: perspectiveId,
        workerName: `${newWorker?.firstName} ${newWorker?.lastName}`,
        email: newWorker?.email,
        token: fatZebraToken,
        validation: validation,
        ip: ip
    };

    const options = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            'onsite_token': newWorker?.onsiteToken
        },
    } as RequestInit;

    return fetch(`/api/v1/worker/${employeeId}/portal/${portalId}/company/${companyId}/cart/${cartId}/complete-checkout?token=${token}`, options)
        .then(res => {
            if (res.ok) {
                console.log('Complete checkout');
            }
            return res.json();
        })
        .catch(err => {
            console.log(err);
        });
};
